import { Modal, ModalBody, Spinner } from "reactstrap";
import LogoutIcon from "../Icons/LogoutIcon";

const LogoutModal = ({ modal, toggle, HandleLogout, logoutLoading }) => {
  return (
    <Modal isOpen={modal} toggle={toggle} centered>
      <ModalBody>
        <div className="d-flex flex-column justify-items-center align-items-center gap-4">
          <span className="icon">
            <LogoutIcon />

          </span>
          <p className="text-center mb-4 fs-4">Are you sure, <br /> You want to logout ?</p>
          <div className="row m-0 w-100">
            <div className="col-6 ps-0 pe-3">
              <button
                type="button"
                className="btn btn-secondary w-100 fw-medium fs-4"
                onClick={toggle}
              >
                Cancel
              </button>
            </div>
            <div className="col-6 pe-0 ps-3">
              <button type="button"
                className="btn btn-primary w-100 fw-medium fs-4"
                onClick={HandleLogout}>
                {logoutLoading ? <Spinner /> : "Yes"}
              </button>
            </div>


          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LogoutModal;
